(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manola-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('manola-reels')) {
    customElements.define('manola-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.track = this.querySelector('.manola-reels__track');
        this.previous = this.querySelector('[data-reel-prev]');
        this.next = this.querySelector('[data-reel-next]');
        this.counter = this.querySelector('[data-reel-count]');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), {passive:true});
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-reel-open]');
          if (trigger) {
            const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.reelOpen));
            dialog.showModal();
            dialog.querySelector('video').play().catch(() => {});
          }
          if (event.target.closest('[data-reel-close]')) event.target.closest('dialog').close();
        });
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => { dialog.querySelector('video').pause(); });
        });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.bound = false; }
      move(direction) {
        const card = this.track.querySelector('article');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({left:direction * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        const cards = Array.from(this.track.querySelectorAll('article'));
        const left = this.track.scrollLeft;
        this.previous.disabled = left < 3;
        this.next.disabled = left >= this.track.scrollWidth - this.track.clientWidth - 3;
        const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - cards[0].offsetLeft - left) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - left) ? index : best, 0);
        this.counter.textContent = (nearest + 1) + ' / ' + cards.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
